import { Check, Copy } from "lucide-react";
import { useCallback, useMemo, useState } from "react";
import { usePaperCitationsApi } from "../../api/citations";
import {
  enrichCitations,
  formatContentWithReferences,
} from "../../utils/citationFormat";
import { extractCitations } from "../../utils/citations";
import { ActionButton } from "./ActionButton";

interface Props {
  content: string;
}

export const CopyMessageButton = ({ content }: Props) => {
  const [copied, setCopied] = useState(false);
  const { fetchCitationMetadata } = usePaperCitationsApi();

  const messageCitations = useMemo(
    () => extractCitations(content),
    [content],
  );

  const handleCopy = useCallback(async () => {
    try {
      const enriched = await enrichCitations(
        messageCitations,
        fetchCitationMetadata,
      );
      const text =
        enriched.length > 0
          ? formatContentWithReferences(content, enriched)
          : content.trim();
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy response:", err);
    }
  }, [content, messageCitations, fetchCitationMetadata]);

  return (
    <ActionButton label={copied ? "Copied!" : "Copy message"} onClick={handleCopy}>
      {copied ? (
        <Check className="h-3.5 w-3.5 text-green-500" />
      ) : (
        <Copy className="h-3.5 w-3.5" />
      )}
    </ActionButton>
  );
};
